import { neutralColors, linkColors } from '../tokens/color';

export const enecoProgressIndicatorTokensColors = {
  progressIndicatorItemDefault: neutralColors.neutral400,
  progressIndicatorItemDisabled: neutralColors.neutral300,
  progressIndicatorItemActive: linkColors.linkBrand,
  progressIndicatorItemBorderColor: linkColors.linkBrand,
};
